<template>
    <div class="screen-reader-button" :class="playing ? 'screen-reader-button-playing' : ''">
        <button v-on:click.stop.prevent="click" aria-label="Læs op">
            <no-drag-image src="@/assets/speaker/speaker-light.png" v-if="theme === 'light' && !playing" :scale="scale" />
            <no-drag-image src="@/assets/speaker/speaker-light-active.png" v-if="theme === 'light' && playing" :scale="scale" />

            <no-drag-image src="@/assets/speaker/speaker-dark.png" v-if="theme === 'dark' && !playing" :scale="scale" />
            <no-drag-image src="@/assets/speaker/speaker-dark-active.png" v-if="theme === 'dark' && playing" :scale="scale" />
        </button>
    </div>
</template>

<script>
    import NoDragImage from "@/sgi/common/NoDragImage";

    export default {
        name: 'screen-reader-button',
        components: {NoDragImage},
        props: {
            message: {
                type: String
            },
            theme: {
                type: String,
                default: 'dark',
            }
        },
        data() {
            return {
                playing: false,
                scale: .8,
            }
        },
        methods: {
            click() {
				sgiTTS.stop();

            	if (this.playing) {
					this.playing = false;
				} else {
					this.playing = true;

					sgiTTS.speak(this.message).then((response) => {
						this.playing = false;
					})
				}
            },
        },
    }
</script>

<style lang="scss" scoped>
    .screen-reader-button {
        button {
            cursor: pointer;
            background: transparent;
            border: 1px solid transparent;

            &:focus {
                border: 1px solid white;
            }
        }
    }
</style>
